import projection from '../generated/pw2501f1.json'; import { AcceptanceManifest } from '../types';
export const pw2501f1AcceptanceManifest = projection as AcceptanceManifest;
